import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const FilterIcon = (props) => {
  return (
    <OverlayTrigger
      key={"filterkanban"}
      placement={"top"}
      overlay={
        <Tooltip id={`tooltip-filter`}>
          <strong>Filters</strong>
        </Tooltip>
      }
    >
      <div
        id="filterToggle-content"
        class={`muBtn icon-only filterToggle-btn border ${
          props.params !== 4 ? "mx-margin" : "todo-margin"
        } ${props.show && "_blue_border"}`}
        onClick={props.onClick}
      >
        <span class="svg">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.5 6.75H22.5"
              stroke="#5C5F62"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M5.25 12H18.75"
              stroke="#5C5F62"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M9.75 17.25H14.25"
              stroke="#5C5F62"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </span>
      </div>
    </OverlayTrigger>
  );
};

export default FilterIcon;
